import type { ReactNode } from "react";
import { darkPageCanvasWashClassName } from "@/lib/page-canvas";
import { cn } from "@/lib/utils";

interface RagChatShellProps {
  children: ReactNode;
  className?: string;
}

/** Chat column: light shell, dark welcome-canvas wash, and border. */
export function RagChatShell({ children, className }: RagChatShellProps) {
  return (
    <div
      className={cn(
        "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-2xl border border-[rgba(15,23,42,0.09)] bg-[var(--chat-shell-bg)] shadow-[var(--shadow-card)] dark:border-white/10 dark:shadow-none",
        darkPageCanvasWashClassName,
        className,
      )}
    >
      {children}
    </div>
  );
}

export const RAG_CHAT_HEADER_CLASS =
  "min-w-0 border-b border-[rgba(15,23,42,0.09)] bg-gradient-to-r from-blue-600/[0.08] to-purple-600/[0.08] px-3 py-3 sm:px-5 dark:border-white/10 dark:from-blue-600/20 dark:to-purple-600/20";

export const RAG_CHAT_HEADER_TITLE_CLASS =
  "truncate font-semibold text-[#101828] dark:text-white";
